export default "__VITE_ASSET__35004d41__"